export enum Currency {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
  DKK = 'DKK',
  SEK = 'SEK',
  NOK = 'NOK',
  JPY = 'JPY',
  KRW = 'KRW',
  AUD = 'AUD',
  CAD = 'CAD',
}
